module.exports = __webpack_public_path__ + "img/emptycart.1d8f8287.png";